import type { RootState } from 'reducers';
import { baseSelect } from '../selector-utils';

// ------------------------------------------------------------------------------------------------
// Simple
// ------------------------------------------------------------------------------------------------

// `baseSelect` walks a dynamic lodash path so it can only type its result as
// `unknown`; the value at this path (with a `''` default) is always a string.
export const selectActiveTool = baseSelect(
  'cloudAdmin.toolsBar.selectedToolButtonName',
  '',
) as (state: RootState) => string;
